<script setup lang="ts">
import bubbles from '~/assets/images/bubbles/firefly-bubbles@2x.webp'

const props = defineProps<{
  data: SectionStatementRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)

const { isDesktop } = useDevice()
</script>

<template>
  <div
    class="container grid-default w-full gap-y-12 overflow-hidden py-12 lg:gap-y-28 lg:pb-16"
    :class="invertedStyles"
  >
    <LazyImage
      v-if="isDesktop"
      loading="lazy"
      class="absolute -bottom-28 -right-80 hidden aspect-square object-contain lg:block"
      :src="bubbles"
      :width="896"
      :height="896"
      alt=""
    />
    <DeliciousSausage
      v-if="isDesktop"
      name="statement"
      class="absolute -top-10 right-0 hidden translate-x-10 lg:block xl:-right-80"
    />
    <div class="col-span-full">
      <Heading
        v-if="data.title"
        :level="level"
        :size="1"
        :is-semantic="isSemantic"
        class="mb-4 uppercase"
      >
        <TextReveal>
          <TextClip class="w-fit bg-[284%_62%]">
            {{ data.title }}
          </TextClip>
        </TextReveal></Heading
      >
      <TextReveal v-if="data.subtitle" :delay="0.5" class="lg:text-l font-medium lg:max-w-lg">{{
        data.subtitle
      }}</TextReveal>
      <CallToAction
        v-if="Array.isArray(data.buttons) && data.buttons.length"
        class="mt-4 lg:mt-8"
        :data="data.buttons"
      />
    </div>
    <div class="col-span-full">
      <div class="flex h-full w-full flex-col gap-4 lg:grid-default lg:items-end">
        <div class="lg:col-span-6 xl:col-span-5">
          <Image
            loading="lazy"
            class="aspect-4/3 w-full object-cover"
            sizes="(min-width: 1280px) calc(41.69vw - 53px), (min-width: 1040px) calc(50vw - 56px), calc(100vw - 32px)"
            :src="
              data.mediaAsset?.responsiveImage
                ? data.mediaAsset.responsiveImage?.src
                : data.mediaAsset?.url
            "
            :srcset="
              data.mediaAsset?.responsiveImage
                ? data.mediaAsset.responsiveImage?.webpSrcSet
                : undefined
            "
            :width="
              data.mediaAsset?.responsiveImage
                ? data.mediaAsset.responsiveImage?.width
                : (data.mediaAsset?.width ?? 660)
            "
            :height="
              data.mediaAsset?.responsiveImage
                ? data.mediaAsset.responsiveImage?.height
                : (data.mediaAsset?.height ?? 495)
            "
            :alt="data.mediaAsset?.alt ?? ''"
          />
        </div>
        <div class="lg:col-span-6 lg:col-start-7 lg:text-right">
          <TextReveal v-if="data.text" class="text-3xl font-medium lg:text-5xl-m">
            {{ data.text }}
          </TextReveal>
        </div>
      </div>
    </div>
  </div>
</template>
